// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__2IpAR","description":"styles_description__22bFm","submitContainer":"styles_submitContainer__lrsi1"};